import { dashboardUsersFilterActions } from '../../constants/filter';
import { asyncAction } from '../common';
import { errorHandlerUnitsQueries } from './dashboards';
import executeDashboardUsersQuery from '../../api/usersDashboard';

export const executeDashboardUsers = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_USERS_QUERY',
    executeDashboardUsersQuery(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const changeUsersEvent = (unitId, event) => ({
  type: 'DASHBOARD_CHANGE_USERS_EVENT',
  unitId,
  event,
});

export const setUsersEventColumnValue = (unitId, id, value) => ({
  type: 'DASHBOARD_SET_USERS_EVENT_COLUMNS_VALUE',
  unitId,
  id,
  value,
});

export const addUsersEventColumn = (unitId) => ({
  type: 'DASHBOARD_ADD_USERS_EVENT_COLUMN',
  unitId,
});

export const deleteUsersEventColumn = (unitId, id) => ({
  type: 'DASHBOARD_DELETE_USERS_EVENT_COLUMN',
  unitId,
  id,
});

export const aggregateUsers = (unitId, id) => ({
  type: 'DASHBOARD_AGGREGATE_USERS',
  unitId,
  id,
});

export const addFilterClause = (unitId) => ({
  type: dashboardUsersFilterActions.ADD_FILTER_CLAUSE,
  unitId,
});

export const removeFilterClause = (unitId, clauseId) => ({
  type: dashboardUsersFilterActions.REMOVE_FILTER_CLAUSE,
  unitId,
  id: clauseId,
});

export const setClausesConcatOperator = (unitId, value) => ({
  type: dashboardUsersFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  unitId,
  value,
});

export const setFilterClauseField = (unitId, clauseId, field, fieldType) => ({
  type: dashboardUsersFilterActions.SET_FILTER_CLAUSE_FIELD,
  unitId,
  id: clauseId,
  field,
  fieldType,
});

export const setFilterClauseValue = (unitId, clauseId, value) => ({
  type: dashboardUsersFilterActions.SET_FILTER_CLAUSE_VALUE,
  unitId,
  id: clauseId,
  value,
});

export const setFilterVisibility = (unitId, value) => ({
  type: dashboardUsersFilterActions.SET_FILTER_VISIBILITY,
  unitId,
  value,
});

export const removeFilter = (unitId) => ({
  type: dashboardUsersFilterActions.REMOVE_FILTER,
  unitId,
});

export const copyFilter = (unitId, clauses) => ({
  type: dashboardUsersFilterActions.COPY_FILTER,
  unitId,
  clauses,
});

export const setFilterClauseOperator = (unitId, clauseId, value, resetClauseValue) => ({
  type: dashboardUsersFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  unitId,
  id: clauseId,
  value,
  resetClauseValue,
});

export const setUsersExposureError = (unitId, error) => ({
  type: 'DASHBOARD_SET_USERS_EXPOSURE_ERROR',
  unitId,
  error,
});
